import { UnitOptions } from "@/components/UnitOptions";
import { useLemonadeContext } from "@/LemonadeProvider";
import { useForm } from "react-hook-form";
import { Unit } from "../internal/types";
import "../styles/NewLemonadeForm.css";
import { useEffect } from "react";

type PurchaseForm = {
    product: string;
    amount: number;
    unit: Unit;
    price: number;
};

export function NewPurchaseForm() {
    const { ingredients, addPurchase, getUnitsForIngredient } = useLemonadeContext();
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
        watch,
        setValue
    } = useForm<PurchaseForm>({ shouldFocusError: false });

    const watchProduct = watch("product", "");
    const watchUnit = watch("unit");

    const onSubmit = async (data: PurchaseForm) => {
        const result = await addPurchase({
            product: data.product,
            amount: { amount: data.amount, unit: data.unit },
            price: data.price,
            date: new Date()
        });
        if (typeof result === "string") {
            alert(result);
        } else {
            alert("Beszerzés rögzítve!");
            reset();
        }
    };

    useEffect(() => {
        const validUnits = getUnitsForIngredient(watchProduct);
        if (validUnits.length > 0 && !validUnits.includes(watchUnit)) {
            const defaultUnit = validUnits[0];
            if (defaultUnit) {
                setValue("unit", defaultUnit);
            }
        }
    }, [watchProduct]);

    return (
        <form onSubmit={handleSubmit(onSubmit)} className="lemonade-form">
            <h1 className="main-title">Új beszerzés</h1>
            <input
                {...register("product", {
                    required: "Az alapanyag neve kötelező",
                    pattern: {
                        value: /^[\p{L}\s]+$/u,
                        message: "Csak betűket és szóközt tartalmazhat"
                    }
                })}
                placeholder="Alapanyag neve"
                list="ingredient-list"
            />
            <datalist id="ingredient-list">
                {[...ingredients].map((name) => (
                    <option key={name} value={name} />
                ))}
            </datalist>
            {errors.product && <span className="error-message">{errors.product.message}</span>}

            <div className="amount-unit-row">
                <input
                    type="number"
                    step="0.01"
                    min="0.01"
                    {...register("amount", {
                        required: "A mennyiség kötelező",
                        valueAsNumber: true,
                        min: { value: 0.01, message: "Legalább 0.01" }
                    })}
                    placeholder="Mennyiség"
                />

                <select {...register("unit", { required: "Válassz mértékegységet!" })}>
                    <UnitOptions ingredient={watchProduct} />
                </select>
            </div>
            {errors.amount && <span className="error-message">{errors.amount.message}</span>}

            <input
                type="number"
                min="1"
                step="1"
                {...register("price", {
                    required: "Az összeg kötelező",
                    valueAsNumber: true,
                    min: { value: 1, message: "Legalább 1 Ft" },
                    validate: (value) => Number.isInteger(value) || "Csak egész szám lehet"
                })}
                placeholder="Összeg (Ft)"
            />
            {errors.price && <span className="error-message">{errors.price.message}</span>}

            <div className="submit-row">
                <button type="submit">Beszerzés rögzítése</button>
            </div>
        </form>
    );
}
